import { render, staticRenderFns } from "./TagCapsule.vue?vue&type=template&id=e083a30a&"
import script from "./TagCapsule.vue?vue&type=script&lang=js&"
export * from "./TagCapsule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports